import React, { Component } from 'react';
import AppLayout from './containers/app-layout.js';
import Login from './containers/login.js';
import ForgotPassword from './containers/forgot-password';
import Register from './containers/register';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom';
import { auth } from './firebase/firebase.js';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory();



function PrivateRoute({ component: Component, authed, ...rest }) {

  if (authed === true) {

    return (

      <Route
        {...rest}
        render={(props) => {

          return <Component {...props} />

        }} />)
  }
  else {

    return (<Switch>
      <Route exact path="/forgot-password" render={(props) => {
        return <ForgotPassword />
      }} />
      <Route exact path="/register" render={(props) => {
        return <Register />
      }} />
      <Route exact path="/login" render={(props) => {
        return <Register />
      }} />
      <Route render={(props) => {
        return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
      }} />
    </Switch>)
  }

}

function PublicRoute({ authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => authed === false
        ? <Login {...props} />
        : <Redirect to='/' />}
    />
  )
}

class App extends Component {

  constructor(props) {

    super(props);
    this.state = { width: 0, height: 0, authed: false, loading: true, };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  componentDidMount() {

    this.removeListener = auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          authed: true,
          loading: false,
        })
      } else {
        this.setState({
          authed: false,
          loading: false
        })
      }
    })
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {

    this.removeListener()
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {

    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {

    //https://github.com/tylermcginnis/react-router-firebase-auth
    return this.state.loading === true ? (
      <section class="hero is-fullheight is-light">
        <div class="hero-body">
          <div class="container">
            <div class="column is-4 is-offset-4" style={{ textAlign: "center" }}>
              <i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </section>
    ) : (
        <Router history={history}>
          <Switch>
            <PublicRoute authed={this.state.authed} path='/login' />
            <PrivateRoute authed={this.state.authed} path='/' component={AppLayout} />
          </Switch>
        </Router>
      );

    // return (

    //   <Router history={history}>
    //     <Switch>
    //       <Route path="/login" component={Login} />
    //       <Route path="/" component={AppLayout} />
    //     </Switch>
    //   </Router>
    // );
  }
}
export default App;


// WEBPACK FOOTER //
// ./src/App.js